import { Routes, Route } from "react-router-dom";
import { Dashboard } from "./pages/Dashboard";
import { ApprovalQueue } from "./pages/ApprovalQueue";
import { Layout } from "./components/Layout";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="approval" element={<ApprovalQueue />} />
      </Route>
    </Routes>
  );
}
